import { Link } from 'gatsby'
import React, { useState, useContext } from 'react'
import { FaAngleLeft } from 'react-icons/fa'
import Phone from '../../assets/phone.svg'
import route from '../../utils/route'
import ModalTeLlamamos from '../modal/teLlamamos'
import styles from './selectorHeader.module.scss'
import { t } from '../../../common/i18n'
import AppContext from '../../context/context'
import { FormattedMessage } from 'react-intl'
import mainLogo from '../../../specific/images/logo.png'

interface Props {
  currentLocation: 'cesta' | 'cita-previa' | 'other'
  onGoBack: () => void
  hideTeLlamamos?: boolean
}
const SelectorHeader = ({
  onGoBack,
  currentLocation,
  hideTeLlamamos,
}: Props) => {
  const { citaPreviaState, cestaState } = useContext(AppContext)
  const [openModal, setOpenModal] = useState(false)
  return (
    <React.Fragment>
      <header className={styles.selector_header}>
        <div className={styles.header_wrapper}>
          <div className={styles.go_back_icon_wrapper} onClick={onGoBack}>
            <FaAngleLeft className={styles.go_back_icon} />
          </div>
          <Link to={route('index')} className={styles.logo_wrapper}>
            <img
              src={mainLogo}
              alt={t('rodi_motor_services')}
              className={styles.header_image}
            />
          </Link>
          {!hideTeLlamamos && (
            <div
              className={styles.phone_icon_wrapper}
              onClick={() => setOpenModal(true)}>
              <Phone className={styles.header_phone_icon} />
              <FormattedMessage id="home.te_llamamos" />
            </div>
          )}
        </div>
      </header>
      <ModalTeLlamamos
        taller={
          currentLocation === 'cesta'
            ? cestaState.selectedTaller.codigo_taller
            : currentLocation === 'cita-previa'
            ? citaPreviaState.selectedTaller.codigo_taller
            : null
        }
        setOpenModal={setOpenModal}
        openModal={openModal}
      />
    </React.Fragment>
  )
}

export default SelectorHeader
